import Title from "../components/TheTitle.vue";
import { getPointTypesMaster, searchPointExchangeMagnifications } from "../api";
import { Authorize } from "../utils/authorize";
export default {
    components: { Title },
    data() {
        return {
            serviceInfo: [],
            form: {
                sourceService: "",
                targetService: "",
                minRatio: null,
                maxRatio: null,
                minValidDays: null,
                maxValidDays: null,
            },
            tableInfo: [],
            infoPage: 1,
            pageSize: 10,
        };
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    methods: {
        formatValidDays(days) {
            if (days === null || days === undefined)
                return "";
            return `${days}日`;
        },
        formatMagnification(value) {
            if (value === null || value === undefined)
                return "";
            return `×${value}`;
        },
        validate() {
            const errors = [];
            const maxMagnification = 99999.99999;
            const validNumberRegex = /^[0-9]*\.?[0-9]*$/;
            const validateNumberString = (value) => {
                if (!value)
                    return { valid: true };
                if (!validNumberRegex.test(value))
                    return { valid: false, type: "format" };
                const parts = value.split(".");
                if (parts.length === 2 && parts[1].length > 5)
                    return { valid: false, type: "decimal" };
                const num = Number(value);
                if (isNaN(num) || num < 0 || num > maxMagnification)
                    return { valid: false, type: "range" };
                return { valid: true };
            };
            // チェック for minRatio
            if (this.form.minRatio !== null && this.form.minRatio !== undefined) {
                const result = validateNumberString(this.form.minRatio.toString());
                if (!result.valid) {
                    switch (result.type) {
                        case "range":
                            errors.push(`交換倍率（最小）は0以上${maxMagnification}以下で入力してください。`);
                            break;
                        case "format":
                            errors.push(`交換倍率（最小）は半角数字で入力してください。`);
                            break;
                        case "decimal":
                            errors.push(`交換倍率（最小）は小数点以下5桁までで入力してください。`);
                            break;
                    }
                }
            }
            // チェック for maxRatio
            if (this.form.maxRatio !== null && this.form.maxRatio !== undefined) {
                const result = validateNumberString(this.form.maxRatio.toString());
                if (!result.valid) {
                    switch (result.type) {
                        case "range":
                            errors.push(`交換倍率（最大）は0以上${maxMagnification}以下で入力してください。`);
                            break;
                        case "format":
                            errors.push(`交換倍率（最大）は半角数字で入力してください。`);
                            break;
                        case "decimal":
                            errors.push(`交換倍率（最大）は小数点以下5桁までで入力してください。`);
                            break;
                    }
                }
            }
            if (this.form.minRatio !== null &&
                this.form.minRatio !== undefined &&
                this.form.maxRatio !== null &&
                this.form.maxRatio !== undefined) {
                if (this.form.minRatio > this.form.maxRatio) {
                    errors.push("交換倍率の最小は最大より小さくなるように入力してください。");
                }
            }
            // 有効期間のチェック（整数で0〜9999）
            if (this.form.minValidDays !== null &&
                this.form.minValidDays !== undefined) {
                if (!Number.isInteger(this.form.minValidDays) ||
                    this.form.minValidDays < 0 ||
                    this.form.minValidDays > 9999) {
                    errors.push("有効期間（最小）は0以上9999以下の整数で入力してください。");
                }
            }
            if (this.form.maxValidDays !== null &&
                this.form.maxValidDays !== undefined) {
                if (!Number.isInteger(this.form.maxValidDays) ||
                    this.form.maxValidDays < 0 ||
                    this.form.maxValidDays > 9999) {
                    errors.push("有効期間（最大）は0以上9999以下の整数で入力してください。");
                }
            }
            if (this.form.minValidDays !== null &&
                this.form.minValidDays !== undefined &&
                this.form.maxValidDays !== null &&
                this.form.maxValidDays !== undefined) {
                if (this.form.minValidDays > this.form.maxValidDays) {
                    errors.push("有効期間の最小は最大よりも小さくなるように入力してください。");
                }
            }
            // 交換元・先サービスの重複チェック
            if (this.form.sourceService &&
                this.form.targetService &&
                this.form.sourceService === this.form.targetService) {
                errors.push("「交換元サービス」と「交換先サービス」はそれぞれ異なる項目を選択してください。");
            }
            return errors;
        },
        async onSearch() {
            const errors = this.validate();
            if (errors.length > 0) {
                alert(errors.join("\n"));
                return;
            }
            const filters = {
                exchange_source_service: this.form.sourceService || undefined,
                exchange_target_service: this.form.targetService || undefined,
                min_effective_period_date: this.form.minValidDays !== null
                    ? Number(this.form.minValidDays)
                    : undefined,
                max_effective_period_date: this.form.maxValidDays !== null
                    ? Number(this.form.maxValidDays)
                    : undefined,
                min_exchange_magnification: this.form.minRatio !== null ? Number(this.form.minRatio) : undefined,
                max_exchange_magnification: this.form.maxRatio !== null ? Number(this.form.maxRatio) : undefined,
            };
            const response = await searchPointExchangeMagnifications(filters);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data?.results || [];
                this.infoPage = 1; // 検索後は1ページ目に戻す
            }
        },
        setInfoPage(page) {
            if (page < 1)
                page = 1;
            if (page > this.infoTotalPages)
                page = this.infoTotalPages;
            this.infoPage = page;
        },
        onEdit(row) {
            this.$router.push({
                path: "/updatePointExchangeMagnification",
                query: {
                    pointExchangeMagnificationId: row.point_exchange_magnification_id,
                    sourceService: row.exchange_source_service,
                    targetService: row.exchange_target_service,
                    exchangeMagnification: row.exchange_magnification.toString(),
                    effectivePeriodDate: row.effective_period_date.toString(),
                },
            });
        },
        onClear() {
            this.form = {
                sourceService: "",
                targetService: "",
                minRatio: null,
                maxRatio: null,
                minValidDays: null,
                maxValidDays: null,
            };
            this.tableInfo = [];
            this.infoPage = 1;
        },
        onDelete(row) {
            this.$router.push({
                path: "/deletePointExchangeMagnification",
                query: {
                    pointExchangeMagnificationId: row.point_exchange_magnification_id,
                    sourceService: row.exchange_source_service,
                    targetService: row.exchange_target_service,
                    exchangeMagnification: row.exchange_magnification.toString(),
                    effectivePeriodDate: row.effective_period_date.toString(),
                },
            });
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            const response = await getPointTypesMaster();
            this.serviceInfo = response.data.results;
        }
    },
};
